import { render, staticRenderFns } from "./uploadImgBtn.vue?vue&type=template&id=17ae1dbd"
import script from "./uploadImgBtn.vue?vue&type=script&lang=js"
export * from "./uploadImgBtn.vue?vue&type=script&lang=js"
import style0 from "./uploadImgBtn.vue?vue&type=style&index=0&id=17ae1dbd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports